import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy } from '@ngneat/until-destroy';
import { CustomValidators } from 'src/utils/custom-validators/custom-validators';

@UntilDestroy()
@Component({
    selector: 'ca-med-edit-tags-dialog',
    templateUrl: './MED-edit-tags-dialog.component.html',
    styleUrls: ['./MED-edit-tags-dialog.component.scss'],
})
export class MEDEditTagsDialogComponent implements OnInit {
    @Input() title: string;
    @Input() inputLabel: string;
    @Input() confirmText: string;
    @Input() cancelText: string;
    @Input() selectedFiles: string;
    @Input() selectedFileIDs: string[];
    @Input() placeholder: string;
    @Input() titleKey: string;

    @Output() applyTagsEvent: EventEmitter<{ customTags: string[]; fileIDs: string[] }> = new EventEmitter<{
        customTags: string[];
        fileIDs: string[];
    }>();

    formGroup: UntypedFormGroup;
    isTyping = false;
    tags: string[] = [];
    showIcons = false;

    constructor(
        private activeModal: NgbActiveModal,
        private formBuilder: UntypedFormBuilder,
        private el: ElementRef,
    ) {}

    ngOnInit(): void {
        this.formGroup = this.formBuilder.group({
            value: ['', [Validators.required, CustomValidators.NotContainingOnlyWhitespaces()]],
        });
    }

    close(): void {
        this.activeModal.close();
    }

    addTag(): void {
        const tagValue: string = this.formGroup.get('value')?.value;

        if (tagValue.trim() !== '') {
            if (!this.tags.includes(tagValue.trim())) {
                this.tags.push(tagValue.trim());
            }
            this.onResetInput();
        }
    }

    removeTag(tag: string): void {
        const index = this.tags.indexOf(tag);

        if (index !== -1) {
            this.tags.splice(index, 1);
        }
    }

    dismiss(): void {
        this.activeModal.dismiss('canceled');
    }

    submit(): void {
        this.applyTagsEvent.emit({ customTags: this.tags, fileIDs: this.selectedFileIDs });
        this.activeModal.close();
    }

    enableSubmitButton(): boolean {
        return this.tags.length > 0;
    }

    handleInputFocus(): void {
        this.showIcons = true;
    }

    @HostListener('document:click', ['$event.target'])
    handleDocumentClick(target): void {
        if (!this.el.nativeElement.contains(target)) {
            this.showIcons = false;
        }
    }

    onInputChange(): void {
        if (this.formGroup.value.value.trim() !== '') {
            this.isTyping = true;
        } else {
            this.isTyping = false;
        }
    }

    onResetInput(): void {
        this.formGroup.get('value')?.setValue('');
    }
}
